/* auto-address.js — robust init for Google Places autocomplete
   Initializes when Step 4 becomes visible (click or programmatic) and
   retries until google.maps.places is ready. */
let autocomplete;
let autocompleteInitialized = false;
let initRetryTimer = null;

function initAutocomplete() {
  if (autocompleteInitialized) return; // already done

  const addressInput = document.getElementById('address');
  if (!addressInput) {
    console.warn("Address input not found when trying to init autocomplete.");
    return;
  }

  // Wait until Google API is loaded
  if (typeof google === 'undefined' || !google.maps || !google.maps.places) {
    // Avoid multiple rapidly queued timers
    if (!initRetryTimer) {
      console.log("Google Maps API not ready yet — will retry initAutocomplete()");
      initRetryTimer = setTimeout(() => {
        initRetryTimer = null;
        initAutocomplete();
      }, 300);
    }
    return;
  }

  try {
    autocomplete = new google.maps.places.Autocomplete(addressInput, {
      types: ["address"],
      componentRestrictions: { country: "gb" },
      fields: ["address_components", "formatted_address"]
    });

    autocomplete.addListener('place_changed', fillInAddress);
    autocompleteInitialized = true;
    console.log("✅ Google Autocomplete initialized");
  } catch (err) {
    console.error("Error initializing Google Autocomplete:", err);
  }
}

function fillInAddress() {
  if (!autocomplete) return;
  const place = autocomplete.getPlace();
  if (!place || !place.address_components) return;

  // Clear existing values
  ['address', 'city', 'postcode'].forEach(id => {
    const el = document.getElementById(id);
    if (el) el.value = '';
  });

  // Map components
  place.address_components.forEach(component => {
    const types = component.types || [];

    if (types.includes('postal_code')) {
      const el = document.getElementById('postcode');
      if (el) el.value = component.long_name;
    }

    if (types.includes('postal_town') || types.includes('locality')) {
      const el = document.getElementById('city');
      if (el) el.value = component.long_name;
    }

    if (types.includes('route')) {
      const streetEl = document.getElementById('address');
      if (streetEl) streetEl.value = component.long_name + ' ' + (streetEl.value || '');
    }

    if (types.includes('street_number')) {
      const streetEl = document.getElementById('address');
      if (streetEl) streetEl.value = component.long_name + ' ' + (streetEl.value || '');
    }
  });
}

// When Step 4 becomes visible (click or programmatic open), initialize
document.addEventListener("DOMContentLoaded", () => {
  const step4Header = document.querySelector('#step-4 .accordion-header');
  const step4Content = document.querySelector('#step-4 .accordion-content');

  if (!step4Header && !step4Content) {
    console.warn("Step 4 header/content not found on page.");
    return;
  }

  // 1) If header is clicked by user
  if (step4Header) {
    step4Header.addEventListener('click', () => {
      initAutocomplete();
    });
  }

  // 2) Observe header class changes (openStep() sets header.classList.add('active'))
  if (step4Header && typeof MutationObserver !== 'undefined') {
    const headerObserver = new MutationObserver(mutations => {
      for (const m of mutations) {
        if (m.type === 'attributes' && m.attributeName === 'class') {
          if (step4Header.classList.contains('active')) {
            initAutocomplete();
          }
        }
      }
    });
    headerObserver.observe(step4Header, { attributes: true });
  }

  // 3) Fallback: observe style attribute of the content (display:block)
  if (step4Content && typeof MutationObserver !== 'undefined') {
    const contentObserver = new MutationObserver(() => {
      const visible = getComputedStyle(step4Content).display === 'block';
      if (visible) initAutocomplete();
    });
    contentObserver.observe(step4Content, { attributes: true, attributeFilter: ['style', 'class'] });
  }

  // 4) If Step 4 is already active on load, init immediately
  if (step4Header && step4Header.classList.contains('active')) {
    initAutocomplete();
  }
});
